import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertService, MenuService, OperacionesTipoService, UsuariosService } from '@app/_services';
import { TranslateService } from '@ngx-translate/core';
import { first } from 'rxjs/operators';

@Component({
  selector: 'app-operacionesTipoDetalle',
  templateUrl: './operacionesTipoDetalle.component.html'
})
export class OperacionesTipoDetalleComponent implements OnInit {

  navigationSubscription;

  form: FormGroup;
  id: string;
  isAddMode: boolean;
  loading = false;
  submitted = false;

  tipoLista: any;
  tipoSeleccionado: any;
  user = this.userService.userValue;

  constructor(
    private operacionesTipoService: OperacionesTipoService,
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private translateService: TranslateService,
    private alertService: AlertService,
    private userService: UsuariosService,
    private menuService: MenuService
  ) {

    this.menuService.titulo = this.translateService.instant('operacionestipo').toUpperCase();

  }

  ngOnInit() {
    this.id = this.route.snapshot.params['id'];
    this.isAddMode = !this.id;

    this.form = this.formBuilder.group({
      id: this.route.snapshot.params['id'],
      nombre: new FormControl('', [Validators.required, Validators.maxLength(50)]),
      tipo: new FormControl(undefined, [Validators.required]),
    });

    this.operacionesTipoService.Get_TipoOperacionTipo_Combo().subscribe((result) => {
      var datuak: any = result;
      this.tipoLista = datuak;
      this.tipoSeleccionado = this.tipoLista[0];
      this.form.controls['tipo'].setValue(this.tipoSeleccionado);

      if (!this.isAddMode) {
        this.operacionesTipoService.getById(this.id).pipe(first()).subscribe((result) => {
          this.tipoSeleccionado = this.tipoLista.find(x => x.id === result.tipoId);
          this.form.patchValue(result);
          this.form.controls['tipo'].setValue(this.tipoSeleccionado);
        });
      }

    });

  }

  // convenience getter for easy access to form fields
  get f() { return this.form.controls; }

  onSubmit() {
    this.submitted = true;

    // reset alerts on submit
    this.alertService.clear();

    // stop here if form is invalid
    if (this.form.invalid) {
      return;
    }

    this.loading = true;
    if (this.isAddMode) {
      this.crearTipoOperacion();
    } else {
      this.updateTipoOperacion();
    }

  }

  private crearTipoOperacion() {
    this.operacionesTipoService.create(-1, this.form.value.nombre, this.form.value.tipo.id)
      .pipe(first())
      .subscribe({
        next: () => {
          this.alertService.success(this.translateService.instant('creadocorrectamente'), { keepAfterRouteChange: true });
          this.router.navigate(['operacionestipo/']);
        },
        error: error => {
          this.alertService.error(error);
          this.loading = false;
        }
      });
  }

  private updateTipoOperacion() {
    this.operacionesTipoService.update(this.form.value.id, this.form.value.nombre, this.form.value.tipo.id)
      .pipe(first())
      .subscribe({
        next: () => {
          this.alertService.success(this.translateService.instant('editadocorrectamente'), { keepAfterRouteChange: true });
          this.router.navigate(['operacionestipo/']);
        },
        error: error => {
          this.alertService.error(error);
          this.loading = false;
        }
      });
  }

}
